import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertsvarService } from '../../alertsvar.service';
import { KeyValue } from '@angular/common';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-show-popup-events',
  templateUrl: './show-popup-events.component.html',
  styleUrls: ['./show-popup-events.component.scss']
})
export class ShowPopupEventsComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: MatDialogRef<ShowPopupEventsComponent>,
    private alertvarservice: AlertsvarService
  ) { }
  $destroy: Subject<boolean> = new Subject()
  selectedEventKey: string
  eventIndex: number
  eventView: any = {}
  alertActionMetadata: any = this.alertvarservice.updateActionMetadata
  alertKey = "";
  numberofevents: number = 1
  ngOnInit(): void {

//consoe.log(this.data)

    this.eventIndex = this.data.startIndex
    //console.log("ShowPopupEventsComponent======", this.data, this.alertvarservice.alertWorkFlowInfo.alertKeys_list)

    this.pickPopupEvent()
  }

  pickPopupEvent() {
    if (this.data.mode == 'Alerts') {
      this.selectedEventKey = this.alertvarservice.AlertEventsKeyList[this.eventIndex]
//consoe.log("Selected Key =----> ",this.selectedEventKey)
      this.numberofevents = this.alertvarservice.AlertEventsKeyList.length
      this.eventView = JSON.parse(JSON.stringify(this.alertvarservice.AlertEvents[this.selectedEventKey]))
      // this.alertKey = this.eventView.alerttime.toString() + this.eventView.seq_no.toString()
      this.alertKey = JSON.stringify((this.alertvarservice.eventsItemperpage.value * this.alertvarservice.eventspagenumber) - this.alertvarservice.eventsItemperpage.value + this.eventIndex + 1)

//consoe.log("Alert Key =---->" , this.alertKey)
      // this.eventView['status_disp'] = this.alertActionMetadata.action_disp[this.eventView.status]['status_disp']
      // this.eventView['alertstate_disp'] = this.alertActionMetadata.action_disp[this.eventView.status]['state_disp']
    }
    else {
      this.selectedEventKey = this.alertvarservice.alertWorkFlowInfo.alertKeys_list[this.eventIndex]
      this.numberofevents = this.alertvarservice.alertWorkFlowInfo.alertKeys_list.length
      this.eventView = this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEventKey]
      // this.eventView['status_disp'] = this.alertActionMetadata.action_disp[this.eventView.status]['status_disp']
      // this.eventView['alertstate_disp'] = this.alertActionMetadata.action_disp[this.eventView.status]['state_disp']

    }
    this.eventView['status_disp'] = this.alertActionMetadata.states.status[this.alertvarservice.AlertEvents[this.selectedEventKey].status]['disp']
    this.eventView['alertstate_disp'] = this.alertActionMetadata.states.status[this.alertvarservice.AlertEvents[this.selectedEventKey].status]['state'][this.alertvarservice.AlertEvents[this.selectedEventKey].alertstate]['disp']
    //console.log(this.numberofevents, this.eventIndex, this.eventView)
  }

  paginationTable_click(direction: number) {
    if (direction == 1) {
      if (this.numberofevents - 1 >= this.eventIndex + 1) {
        this.eventIndex += 1
        this.pickPopupEvent()
      }
    }
    else {
      if (this.eventIndex - 1 >= 0) {
        this.eventIndex -= 1
        this.pickPopupEvent()
      }
    }
  }
  clickAction() {
    this.eventView.isSelected = !this.eventView.isSelected
    // this.alertvarservice.
    //console.log("2==============", this.selectedEventKey, this.eventView.isSelected, this.alertvarservice.AlertEvents)

    if (this.data.mode == 'Alerts') {
      this.alertvarservice.AlertEvents[this.selectedEventKey].isSelected = this.eventView.isSelected
      if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(this.selectedEventKey)) {
        this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEventKey].isSelected = this.eventView.isSelected
      }
      if (this.eventView.isSelected) {
        this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEventKey] = this.eventView
      }
      else {
        if (this.alertvarservice.alertWorkFlowInfo.selectedAlerts.hasOwnProperty(this.selectedEventKey)) {
          delete this.alertvarservice.alertWorkFlowInfo.selectedAlerts[this.selectedEventKey]
          this.alertvarservice.alertWorkFlowInfo.alertKeys_list?.splice(this.alertvarservice.alertWorkFlowInfo.alertKeys_list.indexOf(this.selectedEventKey), 1)
        }
      }
      let isAnyFalse = false
      for (let elementKey in this.alertvarservice.AlertEvents) {
        if (!this.alertvarservice.AlertEvents[elementKey].isSelected) {
          isAnyFalse = true
          break
        }
      }
      //console.log("isAnyFalse==================================", isAnyFalse)
      if (isAnyFalse) {
        this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })

      }
      else {
        this.alertvarservice.eventsSelectAll.setValue(true, { emitEvent: false })
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
      }
    }
    else {


      let selectedAlertStatus = true
      if (this.alertvarservice.alertWorkFlowInfo.alertKeys_list.length != 0) {
        this.alertvarservice.alertWorkFlowInfo.alertKeys_list.forEach((item) => {
          //console.log(item, !this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected)
          if (!this.alertvarservice.alertWorkFlowInfo.selectedAlerts[item].isSelected) {
            selectedAlertStatus = false
            // return false
          }
        })
      }
      else {
        selectedAlertStatus = false
      }

      //console.log("changeTab==========", selectedAlertStatus)
      if (selectedAlertStatus) {
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(true, { emitEvent: false })
        if (this.alertvarservice.alertWorkFlowInfo.alertKeys_list.length == this.alertvarservice.AlertEventsKeyList.length) {
          this.alertvarservice.eventsSelectAll.setValue(true, { emitEvent: false })
        }
        // this.alertvarservice.eventsSelectAll.setValue(,{emitEvent:false})
      }
      else {
        this.alertvarservice.alertWorkFlowInfo.alertWorkFlowSelectAll.setValue(false, { emitEvent: false })
        this.alertvarservice.eventsSelectAll.setValue(false, { emitEvent: false })
      }
      //console.log("1================", this.selectedEventKey, this.eventView.isSelected, this.alertvarservice.AlertEvents)
    }
  }
  closedialogClick() {
    this.ref.close(true)
  }

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  ngOnDestroy(): void {
    this.$destroy.next(true);
  }
}
